import React, { Fragment, useEffect } from "react";
import { Box, Card, Tooltip, Typography } from "@material-ui/core";
import {
  checkinDetailSelector,
  surveySummarySelector,
} from "Recoil/Checkins/selector";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
import { useRecoilValue, useSetRecoilState } from "recoil";
import moment from "moment";
import {
  KENDO_DATE_FORMAT,
  STATUS,
  TIME_VALIDATION_FORMAT,
} from "src/constants";
import { get, isNull, map } from "lodash";
import StarIcon from "Assets/images/grey-star.svg";
import Lock from "Assets/images/lock.svg";
import { useStyles } from "./styles";
// import { SurveyDetail } from "Assets/index";
import { coacheeLabel, coachLabel, displayIcon } from "../utils";
import ShowMoreButton from "../../../../components/formControls/HookFields/DescriptionEllipsis";
import CheckinSummaryStats from "Components/CheckinSummaryStats";
import { useCheckin } from "Hooks/checkin/useCheckin";
import { FrequencyFilter } from "../RightPanel/Common";
// import { useCheckinDetailGrid } from "Hooks/checkin/useCheckinDetailGrid";
import { useCheckinDetails } from "Hooks/checkin/useCheckinDetails";
import { checkinSRSDetailsState } from "Recoil/Targets/atom";
import { checkinDetailsVariables } from "Recoil/Checkins/atom";
// import HeaderFilters from "../SkillRatingPanel/Common/HeaderFilters";
import { checkArrayLength } from "src/utils";
import { useRoleAndPermission } from "Hooks/permissions/useRoleAndPermission";

const LeftPanel = ({
  skillRatee,
  setSkillRatee,
  sortSelected,
  selectedSkillName,
  selectedFrequency,
  setSelectedFrequency,
  checkinId,
}) => {
  const classes = useStyles();
  const checkinDetail = useRecoilValue(checkinDetailSelector);
  const {
    checkInType,
    name,
    startDate,
    endDate,
    description,
    allCheckinViewers,
    usersForCheckin,
    allCheckinRatees,
    allCheckinRaters,
    checkinCoach,
    surveyCheckin,
    createdBy,
    checkInStatus,
    id,
    checkinFrequencyDates,
  } = checkinDetail;

  const {
    getSurveyResponseSummaryReport,
    responseSummaryLoader,
    SRSCheckinDetails,
  } = useCheckin();
  const { handlePendingUserPermission } = useRoleAndPermission();
  const pendingUsersCondition = handlePendingUserPermission();
  const { getLearning, getSurveyQuestionWise, getSurveyPeopleWise, setLoader } =
    useCheckinDetails();
  const { skills } = useRecoilValue(checkinSRSDetailsState);
  const surveySummary = useRecoilValue(surveySummarySelector);
  const setSRSDetails = useSetRecoilState(checkinSRSDetailsState);
  const setCheckinDetailsVariables = useSetRecoilState(checkinDetailsVariables);
  const { completedUsers, totalUsers, average } = surveySummary;

  useEffect(() => {
    if (checkinId) {
      getSurveyResponseSummaryReport({
        variables: {
          checkinId: checkinId,
          sequenceNo: get(selectedFrequency, "checkinSequenceNo", 0),
        },
      });
    }
  }, [checkinId, get(selectedFrequency, "checkinSequenceNo", 0)]);

  useEffect(() => {
    if (
      checkArrayLength(allCheckinRatees) &&
      !allCheckinRatees.find((res) => res.userid === skillRatee?.userid)
    ) {
      setSkillRatee(allCheckinRatees?.[0]);
    }
  }, [allCheckinRatees, skillRatee]);

  useEffect(() => {
    if (checkInType === "SKILLRATING") {
      const variables = {
        input: {
          // id: "ecfb41fd-5710-4694-9b93-f46e168004df",
          id,
          sequenceNo: get(selectedFrequency, "checkinSequenceNo", 0),
          // userId: "d1c5468f-0319-485a-92f1-75b569ab62fe",
          userId: skillRatee?.userid,
          isCheckinDetailsView: true,
          skillName: selectedSkillName || skills?.[0]?.skillName,
        },
      };
      setSRSDetails({ loading: true });
      SRSCheckinDetails({ variables });
    }
  }, [skillRatee?.userid, id, selectedSkillName, selectedFrequency]);

  useEffect(() => {
    if (["SURVEY", "REQUESTFEEDBACK"].includes(checkInType)) {
      if (sortSelected === "Group by question") {
        setLoader((res) => ({ ...res, surveyQuestionWiseLoader: true }));
        const variables = {
          checkinId: id,
          sequenceNo: get(selectedFrequency, "checkinSequenceNo", 0),
        };
        getSurveyQuestionWise({ variables });
        setCheckinDetailsVariables(variables);
      } else {
        setLoader((res) => ({ ...res, surveyPeopleWiseLoader: true }));

        getSurveyPeopleWise({
          variables: {
            checkinId: id,
            sequenceNo: get(selectedFrequency, "checkinSequenceNo", 0),
          },
        });
      }
    } else if (checkInType === "LEARNING") {
      setLoader((res) => ({ ...res, learningLoader: true }));

      getLearning({
        variables: {
          checkinId: id,
          sequenceNo: get(selectedFrequency, "checkinSequenceNo", 0),
        },
      });
    }
  }, [sortSelected, selectedFrequency, checkInType, id]);

  const user = (res, key) => {
    return (
      <>
        <Tooltip
          title={`${get(res, "firstName", "")} ${get(res, "lastName", "")} ${
            get(res, "status", "") === "PENDING" ? " (Pending)" : ""
          }`}
        >
          <Box
            display="flex"
            alignItems="center"
            flexDirection="column"
            justifyContent="center"
            mr={1}
            textAlign="center"
            width="55px"
            mb={1}
          >
            <Box
              position="relative"
              mb={0.5}
              className={key === "coach" ? classes.primaryCoachWrapper : ""}
            >
              <UserProfileWidget
                key={key}
                firstName={get(res, "firstName")}
                lastName={get(res, "lastName")}
                url={get(res, "profileImage.fileName")}
                status={get(res, "status")}
              />
              {key === "coach" ? (
                <img
                  alt="Lead reviewer icon"
                  src={StarIcon}
                  className={classes.starIcon}
                />
              ) : (
                ""
              )}
            </Box>
            <Typography
              variant="body2"
              className={`${
                res?.status === "DEACTIVATED"
                  ? classes.deactivateUser
                  : classes.userName
              } font-12`}
            >
              <span>{get(res, "firstName")}</span>
              <span>{get(res, "lastName")}</span>
            </Typography>
          </Box>
        </Tooltip>
      </>
    );
  };

  const anonymousUser = (res, key) => {
    const index = key + 1;
    return (
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        mr={1}
        textAlign="center"
        width="55px"
        mb={1}
      >
        <Box position="relative" mb={0.5}>
          <UserProfileWidget
            key={index}
            firstName="User"
            lastName={index}
            url={null}
          />
        </Box>
        <Typography variant="body2" className={`${classes.userName} font-12`}>
          <span>{`User ${index}`}</span>
        </Typography>
      </Box>
    );
  };

  return (
    <Box className={classes.leftSection}>
      <Card>
        <Box
          px={2}
          py={1.5}
          className={classes.checkinType}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="subtitle1" className={`font-bold font-14`}>
            {/* {checkInType === "SURVEY" ? "Survey" : "Learning check-in"} */}
            {/* {displayTitle(checkInType)} */}
            Summary
            {get(surveyCheckin, "isanonymous", false) && (
              <Tooltip title="Responses are anonymous">
                <img src={Lock} alt="lock icon" className="ml5" width="14px" />
              </Tooltip>
            )}
          </Typography>
          <span
            className={`${
              classes.checkinStatus
            } ${checkInStatus?.toLowerCase()}`}
          >
            {STATUS[checkInStatus]}
          </span>
          {/* <span className={`${classes.checkinStatus} ${checkInStatus.toLowerCase()}`}>{checkInStatus.toLowerCase()}</span> */}
        </Box>
        {
          !responseSummaryLoader && (
            // ["SURVEY", "LEARNING"].includes(checkInType) ? (
            <Box px={2}>
              <CheckinSummaryStats
                completedUsers={completedUsers}
                totalUsers={totalUsers}
                // totalUsersList={totalUsersList}
                average={average}
              />
            </Box>
          )
          // ) : null
        }
        <Box px={2} py={2}>
          <Typography
            variant="body2"
            className={`font-14 font-bold multi-wrap-3`}
          >
            {name}
          </Typography>
          {/* <HeaderFilters
            selectedFrequency={selectedFrequency}
            setSelectedFrequency={setSelectedFrequency}
            skillRatee={skillRatee}
            setSkillRatee={setSkillRatee}
          /> */}
          {/* {checkinFrequencyDates?.length > 0 && ( */}
          <Box mt={2}>
            {/* <Typography variant="subtitle2" className="font-13 font-semibold">
                {"Frequency"}
              </Typography> */}

            <FrequencyFilter
              selectedFrequency={selectedFrequency}
              setSelectedFrequency={setSelectedFrequency}
              checkinFrequencyDates={checkinFrequencyDates}
              label={checkinFrequencyDates?.length ? "Frequency" : null}
            />
          </Box>
          {/* )} */}

          <Box mt={2}>
            <Typography variant="body2" className="font-13">
              <b className="font-semibold">Start:</b>{" "}
              {startDate
                ? moment(startDate).format(
                    `${KENDO_DATE_FORMAT} [at] ${TIME_VALIDATION_FORMAT}`
                  )
                : null}
            </Typography>
            <Typography variant="body2" className="font-13">
              <b className="font-semibold">Due:</b>{" "}
              {endDate
                ? moment(endDate).format(
                    `${KENDO_DATE_FORMAT} [by] ${TIME_VALIDATION_FORMAT}`
                  )
                : null}
            </Typography>
          </Box>
          <Box my={2}>
            <Typography variant="subtitle2" className="font-13 font-bold">
              Instructions
            </Typography>
            <ShowMoreButton description={description} />
          </Box>
          <Box className={classes.media} my={2}>
            {/* {checkInType === "LEARNING" ? (
              <Typography variant="subtitle2" className="font-13 font-bold">
                Learning content
              </Typography>
            ) : (
              ""
            )} */}
            {displayIcon(checkInType, checkinDetail)}
          </Box>
          <Box className={classes.userList}>
            <Typography
              variant="subtitle2"
              className="font-13 font-bold"
              gutterBottom
            >
              Created by
            </Typography>
            <Box mb={1.5}>
              <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                justifyContent="center"
                mr={1}
                textAlign="center"
                width="55px"
                mb={1}
              >
                <UserProfileWidget
                  firstName={get(createdBy, "firstName")}
                  lastName={get(createdBy, "lastName")}
                  url={get(createdBy, "profileImage.fileName")}
                />
              </Box>
            </Box>
            <Typography
              variant="subtitle2"
              className="font-13 font-bold"
              gutterBottom
            >
              {coacheeLabel(checkInType)}
            </Typography>
            <Box display="flex" alignItems="center" flexWrap="wrap" mb={1.5}>
              {surveyCheckin?.isanonymous
                ? (checkInType === "SKILLRATING"
                    ? allCheckinRatees.filter((res) => !res?.isSoftDelete)
                    : map(
                        get(usersForCheckin, "items", []).filter(
                          (res) => !res?.isSoftDelete
                        ),
                        "user"
                      )
                  ).map((res, key) => anonymousUser(res, key))
                : (checkInType === "SKILLRATING"
                    ? allCheckinRatees.filter((res) => !res?.isSoftDelete)
                    : map(
                        get(usersForCheckin, "items", []).filter(
                          (res) => !res?.isSoftDelete
                          // pendingUsersCondition
                          //   ? !res?.isSoftDelete
                          //   : res?.user?.status !== "PENDING" &&
                          //     !res?.isSoftDelete
                        ),
                        "user"
                      )
                  ).map((res, key) => user(res, key))}
            </Box>
            <Typography
              variant="subtitle2"
              className="font-13 font-bold"
              gutterBottom
            >
              {coachLabel(checkInType)}
            </Typography>
            {checkInType !== "REQUESTFEEDBACK" ? (
              <Box display="flex" alignItems="center" flexWrap="wrap">
                {checkinCoach && user(checkinCoach, "coach")}
                {(checkInType === "SKILLRATING"
                  ? allCheckinRaters
                  : allCheckinViewers || []
                )
                  .filter((res) => !res?.isSoftDelete)
                  .map((res, key) => {
                    if (
                      !res.isAddedFromBE &&
                      (!checkinCoach || res.userid !== checkinCoach.id)
                    ) {
                      return user(res, key);
                    } else {
                      return false;
                    }
                  })}
              </Box>
            ) : null}
            {checkInType === "SKILLRATING" ? (
              <Fragment>
                <Typography
                  variant="subtitle2"
                  className="font-13 font-bold"
                  gutterBottom
                >
                  Can view responses
                </Typography>
                <Box display="flex" alignItems="center" flexWrap="wrap">
                  {(allCheckinViewers || [])
                    .filter(
                      (res) =>
                        (!isNull(res?.isSoftDelete) && !res?.isSoftDelete) ||
                        !res?.isAddedFromBE
                    )
                    .map((res, key) => {
                      if (!checkinCoach || res.userid !== checkinCoach.id) {
                        return user(res, key);
                      } else {
                        return false;
                      }
                    })}
                </Box>
              </Fragment>
            ) : null}
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default LeftPanel;
